module.exports = __webpack_public_path__ + "img/kitchen1.288a9a29.jpg";